import * as Highcharts from 'highcharts';
import {} from 'highcharts/modules/exporting';
import {} from 'highcharts/modules/offline-exporting';

import {Directive, OnDestroy, OnInit} from '@angular/core';

import {CockpitCard} from 'shared/dtos/cockpit-card';
import {sleep} from 'shared/utils';
import {ICurrentLocaleComponent} from 'shared/components/current-locale-component';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';
import {Table} from 'shared/services/table-data-export/table-properties';

export interface CockpitContentComponent {
  card: CockpitCard;
  tableHeaders?: string[];
  prepareTables?: (tables: Table[]) => Table[];

  ngOnInit: () => Promise<void>;
  exportCockpit?: () => void;
}

export abstract class CockpitChartComponent {
  chart: Highcharts.Chart;

  async exportChartSVG(): Promise<string[]> {
    while (!this.chart) {
      await sleep(100);
    }
    const result = this.chart.getSVG();
    return [result];
  }
}

@Directive()
export abstract class CockpitChartParentComponent
  extends CockpitChartComponent
  implements CockpitContentComponent
{
  abstract card: CockpitCard;
  abstract chartChildren: CockpitChartComponent[];

  abstract ngOnInit(): Promise<void>;

  async exportChartSVG(): Promise<string[]> {
    let result: string[] = [];
    for (const chartChild of this.chartChildren) {
      const strings = await chartChild.exportChartSVG();
      result = result.concat(strings);
    }
    return result;
  }
}

@Directive()
export abstract class CockpitChartParentComponentWithCurrentLocale
  extends CockpitChartParentComponent
  implements CockpitContentComponent, ICurrentLocaleComponent, OnInit, OnDestroy
{
  crtLocale: string;

  private langChangeSubscription: Subscription;

  constructor(protected readonly translate: TranslateService) {
    super();
  }

  async ngOnInit(): Promise<void> {
    this.langChangeSubscription = this.translate.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.crtLocale = event.lang;
      }
    );
    this.crtLocale = this.translate.currentLang;
  }

  ngOnDestroy(): void {
    this.langChangeSubscription.unsubscribe();
  }
}
